export default __webpack_public_path__ + "static/media/A9.0a975339.png";